const initialState = {
    parentGroups: [],
    count: 0,
    isReadingParentGroups: false,
    isAddingCustomGroup: false,
}

export default initialState;
